import { useEffect, useState } from 'react'
import Layout from 'containers/Layout'
import { Route, Switch, useHistory, useParams } from 'react-router-dom'
import CompanyProfile from 'pages/company/CompanyProfile'
import apiGet from 'lib/network/apiGet'
import { getResourceData } from 'lib/utils/resource'
import BranchProfile from './BranchProfile'
import BranchDiscount from './modals/branchDiscountModal'
import useModal from 'hooks/useModal'
import { useTranslation } from 'react-i18next'
import LanguageSwitcher from 'components/atoms/LanguageSwitcher'

const AddBranch = ({ readOnly, currentUserId }) => {
  const { t } = useTranslation()
  const history = useHistory()

  const [isEdit, setIsEdit] = useState(null)
  const [branchData, setBranchData] = useState({})
  const [discountModalMode, setDiscountModalMode] = useState('set')

  const [loading, setLoading] = useState(false)

  const id = useParams()?.id

  useEffect(() => {
    if (id) {
      setIsEdit(true)
      fetchBranch(id)
    }
  }, [id])

  const fetchBranch = async () => {
    setLoading(true)
    const data = getResourceData(await apiGet(`branch/${id}`))
    setLoading(false)

    if (!data) {
      history.push('/branches')
      return
    }

    setBranchData(data)
  }

  return (
    <Layout
      headerRight={
        <div className="mt-4 flex sm:mt-0 gap-3 sm:space-x-3 rtl:space-x-reverse">
          <button
            onClick={() => {
              history.push('/branches')
            }}
            type="button"
            className="order-0 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm text-normal rounded-md text-white bg-dark-600 hover:bg-dark-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dark-500 sm:order-1"
          >
            {t('addEditPartner.buttons.goBack')}
          </button>
        </div>
      }
      title={isEdit ? t('branchProfile.editBranch') : t('branchProfile.addNewBranch')}
      breadcrumbs={[
        { name: 'Branch List', pathname: '/branches' },
        { name: isEdit ? 'User Details' : 'Add New Users', pathname: '/add/branch', current: true },
      ]}
    >
      <div className="flex overflow-auto">
        <Switch>
          <Route key={id} path="/add/branch" component={() => <BranchProfile id={id} isEdit={isEdit} />} />
          <Route
            key={id}
            path="/branch/:id/branch-profile"
            component={() => <BranchProfile readOnly={readOnly} refetch={fetchBranch} branchData={branchData} loading={loading} id={id} isEdit={isEdit} />}
          />
        </Switch>
      </div>
    </Layout>
  )
}

export default AddBranch
